export enum OpportunityEnum {
  user= 'op.user',
  customHeader = 'op.customHeader',
  token= 'op.token',
  url= 'op.url'
}
